import type {
  AddPaymentRuleReq,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetPaymentRuleRes,
  GetPaymentRulesRes,
  UpdatePaymentRuleReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function usePaymentRule() {
  class PaymentRule<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Payment rule
     * @name PaymentRuleControllerGetPaymentRules
     * @summary Getting a list of payment rules
     * @request GET:/api3/payment-rule
     * @secure
     * @response `200` `GetPaymentRulesRes`
     * @response `400` `BaseErrorResponse`
     */
    paymentRuleControllerGetPaymentRules = (
      query?: {
        /** @example 1 */
        sourceWalletTypeId?: number;
        /** @example 1 */
        targetWalletTypeId?: number;
        /** @example 1 */
        sourceWalletOperationTypeId?: number;
        /** @example 1 */
        targetWalletOperationTypeId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPaymentRulesRes, BaseErrorResponse>({
        path: '/api3/payment-rule',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Payment rule
     * @name PaymentRuleControllerCreatePaymentRule
     * @summary Creating a payment rule
     * @request POST:/api3/payment-rule
     * @secure
     * @response `200` `GetPaymentRuleRes`
     * @response `400` `BaseErrorResponse`
     */
    paymentRuleControllerCreatePaymentRule = (data: AddPaymentRuleReq, params: RequestParams = {}) =>
      this.request<GetPaymentRuleRes, BaseErrorResponse>({
        path: '/api3/payment-rule',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Payment rule
     * @name PaymentRuleControllerUpdatePaymentRule
     * @summary Updating a payment rule
     * @request PUT:/api3/payment-rule/{id}
     * @secure
     * @response `200` `GetPaymentRuleRes`
     * @response `400` `BaseErrorResponse`
     */
    paymentRuleControllerUpdatePaymentRule = (id: number, data: UpdatePaymentRuleReq, params: RequestParams = {}) =>
      this.request<GetPaymentRuleRes, BaseErrorResponse>({
        path: `/api3/payment-rule/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Payment rule
     * @name PaymentRuleControllerDeletePaymentRule
     * @summary Deleting a payment rule
     * @request DELETE:/api3/payment-rule/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    paymentRuleControllerDeletePaymentRule = (id: number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/payment-rule/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new PaymentRule();
}
